import { render, staticRenderFns } from "./violation.vue?vue&type=template&id=5217d92f&scoped=true"
import script from "./violation.vue?vue&type=script&lang=js"
export * from "./violation.vue?vue&type=script&lang=js"
import style0 from "./violation.vue?vue&type=style&index=0&id=5217d92f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217d92f",
  null
  
)

export default component.exports